import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorList = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "var(--main-color)",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			opacity: .01,
			x: 24,
			y: 24,
			width: 24,
			height: 24,
			transform: "rotate(180 24 24)",
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.70741 5.58579L4.0003 6.29289L3.2932 5.58579C3.19943 5.49202 3.07225 5.43934 2.93964 5.43934C2.80703 5.43934 2.67986 5.49202 2.58609 5.58579C2.49232 5.67955 2.43964 5.80673 2.43964 5.93934C2.43964 6.07195 2.49232 6.19913 2.58609 6.29289L3.2932 7L2.58609 7.70711C2.49232 7.80087 2.43964 7.92805 2.43964 8.06066C2.43964 8.19327 2.49232 8.32045 2.58609 8.41421C2.67986 8.50798 2.80703 8.56066 2.93964 8.56066C3.07225 8.56066 3.19943 8.50798 3.2932 8.41421L4.0003 7.70711L4.70741 8.41421C4.80118 8.50798 4.92835 8.56066 5.06096 8.56066C5.19357 8.56066 5.32075 8.50798 5.41452 8.41421C5.50828 8.32045 5.56096 8.19327 5.56096 8.06066C5.56096 7.92805 5.50828 7.80087 5.41452 7.70711L4.70741 7L5.41452 6.29289C5.50828 6.19913 5.56096 6.07195 5.56096 5.93934C5.56096 5.80673 5.50828 5.67955 5.41452 5.58579C5.32075 5.49202 5.19357 5.43934 5.06096 5.43934C4.92835 5.43934 4.80118 5.49202 4.70741 5.58579Z",
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.70741 10.5858L4.0003 11.2929L3.2932 10.5858C3.19943 10.492 3.07225 10.4393 2.93964 10.4393C2.80703 10.4393 2.67986 10.492 2.58609 10.5858C2.49232 10.6796 2.43964 10.8067 2.43964 10.9393C2.43964 11.0719 2.49232 11.1991 2.58609 11.2929L3.2932 12L2.58609 12.7071C2.49232 12.8009 2.43964 12.9281 2.43964 13.0607C2.43964 13.1933 2.49232 13.3204 2.58609 13.4142C2.67986 13.508 2.80703 13.5607 2.93964 13.5607C3.07225 13.5607 3.19943 13.508 3.2932 13.4142L4.0003 12.7071L4.70741 13.4142C4.80118 13.508 4.92835 13.5607 5.06096 13.5607C5.19357 13.5607 5.32075 13.508 5.41452 13.4142C5.50828 13.3204 5.56096 13.1933 5.56096 13.0607C5.56096 12.9281 5.50828 12.8009 5.41452 12.7071L4.70741 12L5.41452 11.2929C5.50828 11.1991 5.56096 11.0719 5.56096 10.9393C5.56096 10.8067 5.50828 10.6796 5.41452 10.5858C5.32075 10.492 5.19357 10.4393 5.06096 10.4393C4.92835 10.4393 4.80118 10.492 4.70741 10.5858Z",
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.70741 15.5858L4.0003 16.2929L3.2932 15.5858C3.19943 15.492 3.07225 15.4393 2.93964 15.4393C2.80703 15.4393 2.67986 15.492 2.58609 15.5858C2.49232 15.6796 2.43964 15.8067 2.43964 15.9393C2.43964 16.0719 2.49232 16.1991 2.58609 16.2929L3.2932 17L2.58609 17.7071C2.49232 17.8009 2.43964 17.9281 2.43964 18.0607C2.43964 18.1933 2.49232 18.3204 2.58609 18.4142C2.67986 18.508 2.80703 18.5607 2.93964 18.5607C3.07225 18.5607 3.19943 18.508 3.2932 18.4142L4.0003 17.7071L4.70741 18.4142C4.80118 18.508 4.92835 18.5607 5.06096 18.5607C5.19357 18.5607 5.32075 18.508 5.41452 18.4142C5.50828 18.3204 5.56096 18.1933 5.56096 18.0607C5.56096 17.9281 5.50828 17.8009 5.41452 17.7071L4.70741 17L5.41452 16.2929C5.50828 16.1991 5.56096 16.0719 5.56096 15.9393C5.56096 15.8067 5.50828 15.6796 5.41452 15.5858C5.32075 15.492 5.19357 15.4393 5.06096 15.4393C4.92835 15.4393 4.80118 15.492 4.70741 15.5858Z",
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 11,
			width: 14,
			height: 2,
			rx: .94,
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 16,
			width: 14,
			height: 2,
			rx: .94,
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 6,
			width: 14,
			height: 2,
			rx: .94,
			fill: "var(--main-color)"
		})
	]
});
export { SvgErrorList as ReactComponent };
